import { render, staticRenderFns } from "./PageMyJourney.vue?vue&type=template&id=6675f9af"
import script from "./PageMyJourney.vue?vue&type=script&lang=js"
export * from "./PageMyJourney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports